import {
  DialogContent,
  Dialog,
  DialogProps,
  useEventCallback,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { memo, useMemo, useState, useEffect } from 'react';
import { useFormik } from 'formik';
import {
  NewResidenceVM,
  PracticeEditResidenceCadastralFields,
} from 'practice/view-models/practice-edit-residence';
import Form from './form';
import * as yup from 'yup';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { PracticeAddress, PracticeAddressRequest } from 'shell/models/practice-address';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { regexOnlyNumber } from 'shell/constants/regex';
import ModalActualResidence from './modal-actual-residence';
import { HttpResponse } from 'shell/models/http-response';
import { TypeRegister } from 'practice/constants/type-register';
import ModalWarning from 'shell/components/shared/modal-warning';
import { ObjectShape } from 'yup/lib/object';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useParams } from 'react-router-dom';
import { CadastralFieldsVisibility } from 'shell/models/practice';
import { AxiosResponse } from 'axios';
import ModalReason from '../../shared/modal-reason';
import { Message } from 'shell/components/shared/search-messages';
import { ResidenceID } from 'practice/constants/id-practice-edit-residence';
import { ISTAT_MILANO } from 'shell/constants/istat-milano';
import { ItalianVM } from 'shell/view-models/register-office-practice-vm';
import { HouseOccupationType, TipoOccupazioneLegittima } from 'practice/constants/house-occupation';
import { validationSchema as newResidenceValidationSchema } from './validation-schema';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

/**
 * Funzione di validazione dello schema
 * @deprecated verrà cancellata in futuro, in favore della costante validationSchema esportata da ./validation-shema
 * @param {boolean} isCadastralFieldsMandatory dati catastali obbligatori
 * @param {TypeRegister} typeRegister tipo registro
 * @returns {yup.AnyObjectSchema}
 */
export const validationSchema = (
  isCadastralFieldsMandatory?: boolean,
  typeRegister?: TypeRegister
): yup.AnyObjectSchema => {
  let schema: ObjectShape = {};

  const isTypeRegisterImmigration = typeRegister === TypeRegister.Immigration;

  const isEmigration = typeRegister === TypeRegister.Emigration;

  schema = {
    checkedResidence: yup.boolean().nullable(),
    italian: yup.object().shape({
      assensoOspitante: yup.boolean().nullable(),
      fiscalCodeProprietario: yup.string().nullable(),
      surnameProprietario: yup.string().nullable(),
      nameProprietario: yup.string().nullable(),
      fiscalCodeOspitante: yup.string().nullable(),
      surnameOspitante: yup.string().nullable(),
      nameOspitante: yup.string().nullable(),
      fiscalCodeERP: yup.string().nullable(),
      fiscalCodeStruttura: yup.string().nullable(),
      nameStruttura: yup.string().nullable(),
      section: yup.string().nullable(),
      sheet: yup
        .string()
        .nullable()
        .matches(regexOnlyNumber, 'Il campo è numerico')
        .max(3, 'Massimo 3 byte'),
      particle: yup
        .string()
        .nullable()
        .matches(regexOnlyNumber, 'Il campo è numerico')
        .max(8, 'Massimo 8 byte'),
      sub: yup
        .string()
        .nullable()
        .matches(regexOnlyNumber, 'Il campo è numerico')
        .max(4, 'Massimo 4 byte'),
      cat: yup.string().nullable(),
      municipality: yup.object().nullable(),
      cap: yup.string().nullable(),
      addressAuto: yup.object().nullable(),
      number: yup.string().nullable(),
      houseOccupation: yup.string().nullable(),
      officeContract: yup.object().nullable(),
      numberContract: yup.string().matches(regexOnlyNumber, 'Il campo è numerico').nullable(),
      dateContract: yup.date().nullable().typeError('Data non valida'),
    }),
  };
  return (
    yup
      .object({
        ...schema,
      })
      // .test('assenso ospitante', 'Controllo', (values) => {
      //   const castedValues = values as unknown as NewResidenceVM;

      //   if (!castedValues.italian?.assensoOspitante) {
      //     return true;
      //   }

      //   if (castedValues.italian?.houseOccupationType === HouseOccupationType.OccupanteLegittimo) {
      //     if (
      //       castedValues.italian?.occupantiLegittimi === TipoOccupazioneLegittima.OspiteProprietario
      //     ) {
      //       const requiredData = [
      //         'fiscalCodeProprietario',
      //         'surnameProprietario',
      //         'nameProprietario',
      //       ] as Array<keyof ItalianVM>;

      //       const errors = requiredData
      //         .map((key) => {
      //           const value = (castedValues?.italian || {})[key];
      //           if (value) {
      //             return null;
      //           } // Successful validation, no error

      //           return new yup.ValidationError('Il campo è obbligatorio', value, `italian.${key}`);
      //         })
      //         .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
      //       if (errors.length === 0) {
      //         return true;
      //       }
      //       return new yup.ValidationError(errors);
      //     }

      //     if (
      //       castedValues.italian?.occupantiLegittimi ===
      //       TipoOccupazioneLegittima.OspiteIntestatarioERP
      //     ) {
      //       const requiredData = [
      //         'fiscalCodeOspitante',
      //         'surnameOspitante',
      //         'nameOspitante',
      //         'fiscalCodeERP',
      //       ] as Array<keyof ItalianVM>;

      //       const errors = requiredData
      //         .map((key) => {
      //           const value = (castedValues?.italian || {})[key];
      //           if (value) {
      //             return null;
      //           } // Successful validation, no error

      //           return new yup.ValidationError('Il campo è obbligatorio', value, `italian.${key}`);
      //         })
      //         .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
      //       if (errors.length === 0) {
      //         return true;
      //       }
      //       return new yup.ValidationError(errors);
      //     }

      //     if (
      //       castedValues.italian?.occupantiLegittimi ===
      //       TipoOccupazioneLegittima.OspiteETSStrutturaSanitariaOPrivate
      //     ) {
      //       const requiredData = ['fiscalCodeStruttura', 'nameStruttura'] as Array<keyof ItalianVM>;

      //       const errors = requiredData
      //         .map((key) => {
      //           const value = (castedValues?.italian || {})[key];
      //           if (value) {
      //             return null;
      //           } // Successful validation, no error

      //           return new yup.ValidationError('Il campo è obbligatorio', value, `italian.${key}`);
      //         })
      //         .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
      //       if (errors.length === 0) {
      //         return true;
      //       }
      //       return new yup.ValidationError(errors);
      //     }
      //     if (
      //       castedValues.italian?.occupantiLegittimi ===
      //       TipoOccupazioneLegittima.OspiteIntestatarioContrattoLocazioneComodatarioUsufruttuario
      //     ) {
      //       const requiredData = [
      //         'fiscalCodeProprietario',
      //         'surnameProprietario',
      //         'nameProprietario',
      //         'fiscalCodeOspitante',
      //         'surnameOspitante',
      //         'nameOspitante',
      //       ] as Array<keyof ItalianVM>;

      //       const errors = requiredData
      //         .map((key) => {
      //           const value = (castedValues?.italian || {})[key];
      //           if (value) {
      //             return null;
      //           } // Successful validation, no error

      //           return new yup.ValidationError('Il campo è obbligatorio', value, `italian.${key}`);
      //         })
      //         .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
      //       if (errors.length === 0) {
      //         return true;
      //       }
      //       return new yup.ValidationError(errors);
      //     }
      //   }

      //   if (
      //     castedValues.italian?.houseOccupationType === HouseOccupationType.Usufruttuario ||
      //     castedValues.italian?.houseOccupationType ===
      //       HouseOccupationType.IntestatarioContrattoAgenziaEntrate ||
      //     castedValues.italian?.houseOccupationType === HouseOccupationType.ComodatarioAgenziaEntrate
      //   ) {
      //     const requiredData = [
      //       'fiscalCodeProprietario',
      //       'surnameProprietario',
      //       'nameProprietario',
      //     ] as Array<keyof ItalianVM>;

      //     const errors = requiredData
      //       .map((key) => {
      //         const value = (castedValues?.italian || {})[key];
      //         if (value) {
      //           return null;
      //         } // Successful validation, no error

      //         return new yup.ValidationError('Il campo è obbligatorio', value, `italian.${key}`);
      //       })
      //       .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
      //     if (errors.length === 0) {
      //       return true;
      //     }
      //     return new yup.ValidationError(errors);
      //   }
      //   // castedValues.italian?.assensoOspitante ?

      //   return true;
      // })
      .test('municipality', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (!castedValues.checkedResidence && !castedValues.italian?.municipality?.description) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.municipality');
        }

        return true;
      })
      .test('addressAuto', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (
          !castedValues.checkedResidence &&
          !castedValues.italian?.addressAuto?.description &&
          !isEmigration
        ) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.addressAuto');
        }

        return true;
      })
      .test('cap', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (!castedValues.checkedResidence && !castedValues.italian?.cap && !isEmigration) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.cap');
        }

        return true;
      })
      .test('number', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (!castedValues.checkedResidence && !castedValues.italian?.number && !isEmigration) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.number');
        }

        return true;
      })
      .test('sheet', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (
          castedValues.italian?.section?.toUpperCase() === 'NC' ||
          castedValues.italian?.section?.toUpperCase() === 'NP'
        ) {
          return true;
        }

        if (
          !castedValues.checkedResidence &&
          !castedValues.italian?.sheet &&
          isCadastralFieldsMandatory &&
          isTypeRegisterImmigration &&
          !castedValues?.italian?.isHomeless
        ) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.sheet');
        }

        return true;
      })
      .test('particle', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (
          castedValues.italian?.section?.toUpperCase() === 'NC' ||
          castedValues.italian?.section?.toUpperCase() === 'NP'
        ) {
          return true;
        }

        if (
          !castedValues.checkedResidence &&
          !castedValues.italian?.particle &&
          isCadastralFieldsMandatory &&
          isTypeRegisterImmigration &&
          !castedValues?.italian?.isHomeless
        ) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.particle');
        }

        return true;
      })
      .test('sub', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (
          castedValues.italian?.section?.toUpperCase() === 'NC' ||
          castedValues.italian?.section?.toUpperCase() === 'NP'
        ) {
          return true;
        }

        if (
          !castedValues.checkedResidence &&
          !castedValues.italian?.sub &&
          isCadastralFieldsMandatory &&
          isTypeRegisterImmigration &&
          !castedValues?.italian?.isHomeless
        ) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.sub');
        }

        return true;
      })
      .test('', 'Controllo Agenzia entrate', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (
          castedValues.italian?.houseOccupationType !==
            HouseOccupationType.IntestatarioContrattoAgenziaEntrate &&
          castedValues.italian?.houseOccupationType !==
            HouseOccupationType.ComodatarioAgenziaEntrate
        ) {
          return true;
        }

        const datiContratto = ['numberContract', 'dateContract', 'officeContract'] as Array<
          keyof ItalianVM
        >;

        const datiCatastali = ['section', 'sheet', 'particle', 'sub', 'cat'] as Array<
          keyof ItalianVM
        >;

        const hasDatiCatastaliPresent = datiCatastali.every((item) => {
          if (!castedValues.italian) {
            return false;
          }

          return !!castedValues.italian[item];
        });

        const hasSomeDatiCatastaliPresent = datiCatastali.some((item) => {
          if (!castedValues.italian) {
            return false;
          }

          return !!castedValues.italian[item];
        });

        const hasSomeDatiContrattoPresent = datiContratto.some((item) => {
          if (!castedValues.italian) {
            return false;
          }

          return !!castedValues.italian[item];
        });

        const hasDatiContrattoPresent = datiContratto.every((item) => {
          if (!castedValues.italian) {
            return false;
          }

          return !!castedValues.italian[item];
        });

        if (!castedValues.checkedResidence && !hasDatiCatastaliPresent) {
          const errors = datiCatastali
            .map((key) => {
              const value = (castedValues?.italian || {})[key];
              if (value) {
                return null;
              } // Successful validation, no error

              return new yup.ValidationError('Il campo è obbligatorio', value, `italian.${key}`);
            })
            .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
          if (errors.length === 0 || hasSomeDatiContrattoPresent) {
            return true;
          }
        }

        if (!castedValues.checkedResidence && !hasDatiContrattoPresent) {
          const errors = datiContratto
            .map((key) => {
              const value = (castedValues?.italian || {})[key];
              if (value) {
                return null;
              } // Successful validation, no error

              return new yup.ValidationError('Il campo è obbligatorio', value, `italian.${key}`);
            })
            .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
          if (errors.length === 0 || hasSomeDatiCatastaliPresent) {
            return true;
          }
          return new yup.ValidationError(errors);
        }

        return true;
      })
      .test('fiscalCodeStruttura', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (
          !castedValues.checkedResidence &&
          castedValues.italian?.houseOccupationType === HouseOccupationType.OccupanteLegittimo &&
          castedValues.italian?.occupantiLegittimi ===
            TipoOccupazioneLegittima.OspiteETSStrutturaSanitariaOPrivate &&
          !castedValues.italian?.fiscalCodeStruttura
        ) {
          return new yup.ValidationError(
            'Campo obbligatorio',
            undefined,
            'italian.fiscalCodeStruttura'
          );
        }

        return true;
      })
      .test('nameStruttura', 'Controllo', (values) => {
        const castedValues = values as unknown as NewResidenceVM;

        if (
          !castedValues.checkedResidence &&
          castedValues.italian?.houseOccupationType === HouseOccupationType.OccupanteLegittimo &&
          castedValues.italian?.occupantiLegittimi ===
            TipoOccupazioneLegittima.OspiteETSStrutturaSanitariaOPrivate &&
          !castedValues.italian?.nameStruttura
        ) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'italian.nameStruttura');
        }

        return true;
      })
  );
};

interface ModalNewResidenceProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onConfirm: (values: NewResidenceVM) => void;
  initialValues?: NewResidenceVM;
  codeEnte?: string;
  typeRegister?: string;
  intestatarioIsAnpr?: boolean;
  yearId?: string;
  progressive?: string;
  typePractice?: string;
  typeResidence?: string;
}

const ModalNewResidenceComponent = ({
  open,
  onClose,
  onConfirm,
  initialValues,
  codeEnte,
  typeRegister,
  yearId,
  progressive,
  intestatarioIsAnpr,
  typeResidence,
  typePractice,
}: ModalNewResidenceProps): React.ReactElement => {
  const { userProfile } = useUserProfile();

  const [openWarning, setOpenWarning] = useState({
    open: false,
    message: '',
    values: {},
    flagMotivo: false,
  });

  const [modalReason, setOpenModalReason] = useState<{ open: boolean; warnings: Message[] }>({
    open: false,
    warnings: [],
  });

  const [openActualResidence, setOpenActualResidence] = useState<
    Record<string, boolean | NewResidenceVM>
  >({
    open: false,
    values: {},
  });
  const params = useParams();

  const [indirizziControloDati, getIndirizziControlloDati] = useHttpFetch<
    HttpResponse<CadastralFieldsVisibility>,
    PracticeEditResidenceCadastralFields
  >(
    `${__PRACTICE_API_URL__}/pratiche/indirizzi/controllo-dati/${params.codiceEnte}-${params.idAnnoPratica}-${params.tipoRegistro}-${params.progressivoPratica}`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponse<CadastralFieldsVisibility>>) => {
        const data = {
          isCadastralFieldsMandatory: response?.data?.payload?.datiObbligatori,
        };
        return data;
      },
    }
  );

  useEffect(() => {
    if (typeRegister === TypeRegister.Immigration) {
      getIndirizziControlloDati();
    }
  }, [typeRegister, getIndirizziControlloDati]);

  const isCambioResidenza = useMemo(() => {
    if (typeRegister === TypeRegister.Residence) {
      return true;
    }

    return false;
  }, [typeRegister]);

  const isImmigrazione = useMemo(() => {
    if (typeRegister === TypeRegister.Immigration) {
      return true;
    }

    return false;
  }, [typeRegister]);

  const isEmigrazione = useMemo(() => {
    if (typeRegister === TypeRegister.Emigration) {
      return true;
    }

    return false;
  }, [typeRegister]);

  const controlData = useHttpClient(
    `${__PRACTICE_API_URL__}/pratiche/registrazione-nuovo-indirizzo/controlli`,
    {
      options: { method: 'POST' },
    }
  );

  const onSubmit = useEventCallback((values: NewResidenceVM) => {
    const data: PracticeAddressRequest = {
      pratica: {
        key: {
          codiceEnte: codeEnte || undefined,
          tipoRegistro: typeRegister || undefined,
          idAnnoPratica: yearId ? Number.parseInt(yearId, 10) : undefined,
          progressivoPratica: progressive ? Number.parseInt(progressive, 10) : undefined,
        },
      },
      casoPratica:
        typeRegister === TypeRegister.RegisterOfficeTemporary
          ? ResidenceID.new
          : typeResidence
          ? typeResidence
          : undefined,
      indirizzo:
        values?.italian && !values?.checkedResidence
          ? {
              tipoOccupanteLegittimo: values.italian?.occupantiLegittimi || undefined,
              flagControlloSiatel: values.italian?.effettuatoControlloSiatel ? '1' : undefined,
              flagConsensoOspitante: values.italian?.occupantiLegittimi
                ? values.italian?.assensoOspitante
                  ? '1'
                  : '0'
                : undefined,
              codSerieAe: values.italian?.serie?.id || undefined,
              // Proprietario
              codFiscaleProprietario: values.italian?.fiscalCodeProprietario || undefined,
              cognomeProprietario: values.italian?.surnameProprietario || undefined,
              nomeProprietario: values.italian?.nameProprietario || undefined,
              comuneProprietario: values.italian?.municipalityResidenceProprietario || undefined,
              descIndirizzoProprietario: values.italian?.addressProprietario || undefined,
              // Ospitante
              codFiscaleOspitante: values.italian?.fiscalCodeOspitante || undefined,
              cognomeOspitante: values.italian?.surnameOspitante || undefined,
              nomeOspitante: values.italian?.nameOspitante || undefined,
              dataNascitaOspitante:
                values?.italian?.dataNascitaOspitante?.toFormat('yyyy-MM-dd') || undefined,
              comuneResidenzaOspitante:
                values?.italian?.municipalityResidenceOspitante?.code?.toString() ||
                values?.italian.municipalityResidenceOspitanteERP ||
                undefined,
              indirizzoOspitante: values.italian?.addressOspitante || undefined,
              // ERP
              // codFiscaleErp: values.italian?.fiscalCodeERP || undefined,
              // Struttura
              codFiscaleEnteOspitante: values.italian?.fiscalCodeStruttura || undefined,
              nomeEnteOspitante: values.italian?.nameStruttura || undefined,
              indirizzoEnteOspitante: values.italian?.addressStruttura || undefined,
              comuneResidenzaEnteOspitante:
                values.italian?.municipalityResidenceStruttura?.code?.toString() || undefined,
              descrizionePecEnte: values.italian?.pecEnteStruttura || undefined,
              // Dati catastali
              flagAssensoAggregazione: values.italian.assensoAggregazione ? '1' : '0',
              flagAggregazioneLegittima: values.italian.aggregazioneLegittima ? '1' : '0',
              flagAssensoOspitante: values.italian.assensoOspitante ? '1' : '0',
              citta: values?.italian.municipality?.description || undefined,
              provincia: values?.italian.municipality?.province || undefined,
              cap: values?.italian?.cap || undefined,
              codVia: values?.italian?.addressAuto?.code || undefined,
              nomeVia: values?.italian?.addressAuto?.description || undefined,
              numeroCivico: values?.italian?.number || undefined,
              esponente: values?.italian?.exponent || undefined,
              // lettera: values?.italian?.letter || undefined,
              sezione: values?.italian?.section || undefined,
              foglio: values?.italian?.sheet || undefined,
              particellaMappale: values?.italian?.particle || undefined,
              subalterno: values?.italian?.sub || undefined,
              categoriaCatastale: values?.italian?.cat || undefined,
              flagIgnotaDimora: values?.italian?.isHomeless ? '1' : '0',
              //nuovi campi
              tipoOccupazione: values?.italian?.houseOccupationType || undefined,
              sedeAgenziaEntrate: values?.italian?.officeContract?.id || undefined,
              dataRegistrazioneAgenziaEntrate:
                values?.italian?.dateContract?.toFormat('yyyy-MM-dd') || undefined,
              numeroRegistrazioneAgenziaEntrate: values?.italian?.numberContract || undefined,
            }
          : undefined,
      indirizzoEstero:
        values?.foreign && values?.checkedResidence
          ? {
              statoEstero: values?.foreign?.foreignState?.province || undefined,
              comune: values?.foreign?.municipality?.description || undefined,
              codComune: values?.foreign?.municipality?.id
                ? Number.parseInt(values?.foreign?.municipality?.id, 10)
                : undefined,
              contea: values?.foreign?.municipality?.province || undefined,
              cap: values?.foreign?.cap || undefined,
              indirizzo: values?.foreign?.address || undefined,
              civico: values?.foreign?.civicNumber || undefined,
              codiceConsolato: values?.foreign?.consulateCode?.id || undefined,
              codiceTerritorio:
                values?.foreign?.territory?.id && values?.foreign?.territory?.value
                  ? values?.foreign?.territory?.id
                  : undefined,
            }
          : undefined,
      proprietario:
        values?.italian &&
        !values?.checkedResidence &&
        (values.italian?.fiscalCodeProprietario || values.italian?.surnameProprietario)
          ? {
              codFiscale: values.italian?.fiscalCodeProprietario || undefined,
              cognome: values.italian?.surnameProprietario || undefined,
              nome: values.italian?.nameProprietario || undefined,
              dataNascita:
                values.italian?.dataNascitaProprietario?.toFormat('yyyy-MM-dd') || undefined,
              tipoProprietario: values.italian?.tipoProprietario || 'F',
            }
          : undefined,
    };

    (controlData({ data }) as ResponsePromise<HttpResponse<PracticeAddress>>).then((response) => {
      const castedResponse = response?.data?.payload as PracticeAddress;

      if (castedResponse?.flagAttualeResidenza) {
        // true se la nuova residenza coincide con quella vecchia, segnalare problema
        setOpenActualResidence({
          open: true,
          values,
        });

        return;
      }

      if ((castedResponse?.warning || []).length > 0) {
        setOpenWarning({
          open: true,
          message: castedResponse?.warning?.join(', ') || '',
          values,
          flagMotivo: castedResponse?.flagMinoreSolo || false,
        });

        return;
      }

      onConfirm(values);
    });
  });

  const formContext = useFormik<NewResidenceVM>({
    initialValues: {
      checkedResidence: initialValues?.checkedResidence
        ? true
        : (isCambioResidenza && intestatarioIsAnpr) || isEmigrazione
        ? true
        : // : isImmigrazione
          // ? false
          false,
      flagAttualeResidenza: initialValues?.flagAttualeResidenza || false,
      italian: {
        section: undefined,
        sheet: '',
        particle: '',
        sub: '',
        cat: undefined,
        cap: undefined,
        addressAuto: undefined,
        number: undefined,
        ...(initialValues?.italian || {}),
        municipality:
          isCambioResidenza && !intestatarioIsAnpr
            ? {
                id: ISTAT_MILANO,
                description: 'MILANO',
                provinceCode: '15',
                province: 'MI',
              }
            : initialValues?.italian?.municipality || {
                description: userProfile.datiLogin?.nomeComune || '',
                province: userProfile.datiLogin?.siglaProvincia || '',
                id: userProfile.datiLogin?.codiceIstat || '',
              },
      },
      foreign: initialValues?.foreign || undefined,
    },
    validationSchema: newResidenceValidationSchema(
      (indirizziControloDati?.data as PracticeEditResidenceCadastralFields)
        ?.isCadastralFieldsMandatory,
      typeRegister as TypeRegister
    ),
    onSubmit,
    enableReinitialize: true,
  });

  const onChange = useEventCallback(
    (key: keyof NewResidenceVM, value: NewResidenceVM[keyof NewResidenceVM]): void => {
      formContext.setFieldValue(key, value);
    }
  );

  const onCloseWarning = useEventCallback(() => {
    const values: NewResidenceVM = openWarning.values as NewResidenceVM;

    if (openWarning.flagMotivo) {
      setOpenModalReason({
        open: true,
        warnings: [{ id: 1, value: openWarning.message }],
      });
      setOpenWarning({ open: false, message: '', values: {}, flagMotivo: false });

      return;
    }

    setOpenWarning({ open: false, message: '', values: {}, flagMotivo: false });

    onConfirm(values);
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <>
      <PmiDialog
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
          Residenza
        </PmiDialogTitle>
        <DialogContent style={{ padding: '30px 24px' }}>
          <Form
            onChange={onChange}
            values={formContext.values}
            errors={formContext.errors}
            touched={formContext.touched}
            isCambioResidenza={isCambioResidenza}
            isImmigrazione={isImmigrazione}
            intestatarioIsAnpr={intestatarioIsAnpr}
            isEmigr={typeRegister === TypeRegister.Emigration}
            typeResidence={typeResidence}
          />
        </DialogContent>
        <DialogActions>
          <PmiButton variant="contained" color="primary" onClick={() => formContext.handleSubmit()}>
            Conferma
          </PmiButton>
          <PmiButton variant="outlined" color="primary" type="button" onClick={() => onClose(true)}>
            Chiudi
          </PmiButton>
        </DialogActions>
      </PmiDialog>
      <ModalActualResidence
        open={openActualResidence.open as boolean}
        onCancel={() => {
          setOpenActualResidence({
            open: false,
            values: {},
          });
        }}
        onOkClose={() => {
          onConfirm({
            ...(openActualResidence.values as NewResidenceVM),
            flagAttualeResidenza: true,
          });

          setOpenActualResidence({
            open: false,
            values: {},
          });
        }}
      />
      <ModalWarning
        open={openWarning.open}
        onClose={onCloseWarning}
        message={openWarning.message}
        withAnnulment
        onAnnulment={() =>
          setOpenWarning({ open: false, message: '', values: {}, flagMotivo: false })
        }
        nameButton="Prosegui"
      />
      {modalReason.open ? (
        <ModalReason
          open={modalReason.open}
          typeRegister={typeRegister}
          yearId={yearId}
          codeEnte={codeEnte}
          progressive={progressive}
          typePractice={typePractice}
          onClose={() => {
            setOpenWarning({
              open: true,
              message: modalReason.warnings[0].value,
              values: formContext.values,
              flagMotivo: true,
            });
            setOpenModalReason({ open: false, warnings: [] });
          }}
          onConfirm={() => {
            setOpenModalReason({ open: false, warnings: [] });
            onConfirm(formContext.values);
          }}
          warnings={modalReason.warnings}
        />
      ) : undefined}
    </>
  );
};

ModalNewResidenceComponent.displayName = 'Modal new residence';

const ModalNewResidence = memo(ModalNewResidenceComponent);

export default ModalNewResidence;
